<template>
  <section class="section_unique">
    <div class="container_title_unique">
      <h2 class="title_bid_form">
        ТВОЯ ИДЕАЛЬНАЯ <br /><span class="color_orange"
          >МЕБЕЛЬ</span
        >
      </h2>
      <div class="box_title_unique">
        <p class="text_title_unique">
          Ваша кухня — отражение вашего стиля. Встроенное освещение, скрытая техника, фурнитура премиум-класса и продуманные акценты, которые подчёркивают индивидуальность вашего интерьера.
        </p>
      </div>
    </div>
    <div class="container_box_unique">
      <div class="box_unique">
        <p class="title_unique">Встроенное освещение мебели</p>
        <!-- <p class="sub_title_unique">
          Помимо эстетической красоты, делает готовку более приятной и
          удобной.Не требует замены больше 10 лет. Несколько цветовых вариантов
          на выбор.
        </p> -->
      </div>
      <div class="box_unique">
        <p class="title_unique">Системы направляющих от BLUM</p>
        <!-- <p class="sub_title_unique">
          Мы можем подготовить любые формы для вашей будущей кухни, чтобы к ней
          подошла ваша встраиваемая техника
        </p> -->
      </div>
      <div class="box_unique">
        <p class="title_unique">Электропривод SERVO-DRIVE от BLUM</p>
        <!-- <p class="sub_title_unique">
          Технологичные и современные. Благодаря выдвижной конструкции, они
          экономят место в зоне использования.
        </p> -->
      </div>
      <div class="box_unique">
        <p class="title_unique">Лотки и разделители BLUM</p>
        <!-- <p class="sub_title_unique">
          Благодаря более функциональной фурнитуре, вы можете сэкономить место,
          добавить новые отсеки, для вина, заготовок, холодного, горячего и др.
        </p> -->
      </div>
    </div>
  </section>
</template>
<style scoped>
.section_unique {
  width: 100%;
  height: fit-content;
  background: rgb(255, 255, 255);
  padding: 6rem 8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.title_bid_form {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: 1.5%;
  text-align: left;
  text-transform: uppercase;
}

.box_title_unique {
  width: 39.6rem;
}
.text_title_unique {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
  letter-spacing: -1%;
  text-align: left;
}
.container_title_unique {
  display: flex;
  justify-content: space-between;
}
.container_box_unique {
  display: flex;
  justify-content: space-between;
}
.box_unique {
  display: flex;
  border-radius: 0.4rem;
  width: 19.4rem;
  height: 16.6rem;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  flex-direction: column;
  padding: 2.8rem;
  gap: 0.8rem;
  justify-content: center;
}
.box_unique:nth-child(1) {
  background-image: url(../assets/img/unique/unique_1.webp);
}

.box_unique:nth-child(2) {
  background-image: url(../assets/img/unique/unique_2.webp);
}

.box_unique:nth-child(3) {
  background-image: url(../assets/img/unique/unique_3.webp);
}

.box_unique:nth-child(4) {
  background-image: url(../assets/img/unique/unique_4.webp);
}
.title_unique {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
}
.sub_title_unique {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: -2%;
  text-align: left;
}
@media (max-width: 767px) {
  .section_unique {
    padding: 1.7rem 2.4rem 4rem 2.4rem;
  }
  .text_title_unique {
    display: none;
  }
  .container_box_unique {
    flex-direction: column;
    gap: 0.6rem;
  }
  .box_unique {
    width: 100%;
    height: 15.07rem;
    padding: 2.5rem;
    gap: 1.2rem;
  }
  .title_unique {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 1.64rem;
  }
  .sub_title_unique {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.14rem;
  }
}
</style>
